// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_25-1";
export var rateTableServiceLevelDropdown = "_25-3";
export var rateTableTypeDropdown = "_25-0";
export var rateTableValueModeDropdown = "_25-2";